import classNames from 'classnames';
import React, {
  JSX,
  memo,
  PropsWithChildren,
  ReactEventHandler,
  LegacyRef,
  forwardRef,
  ReactElement,
} from 'react';

import styles from './SelectableListItem.styles.m.css';

export type TSelectableListItemSize = 'small-1' | 'small-2' | 'medium-1' | 'medium-2';

export interface ISelectableListItemProps {
  icon?: JSX.Element;
  onClick: ReactEventHandler<HTMLButtonElement>;
  className?: string;
  isDisabled?: boolean;
  dataTest?: string;
  isSelected?: boolean;
  title: string;
  secondaryTitle?: string;
  size?: TSelectableListItemSize;
  suffix?: ReactElement;
}

export const SelectableListItem = memo(
  forwardRef<HTMLElement, PropsWithChildren<ISelectableListItemProps>>((props, ref) => {
    const {
      icon,
      onClick,
      className,
      isDisabled,
      dataTest,
      title,
      secondaryTitle,
      isSelected,
      size = 'small-2',
      suffix,
    } = props;

    const containerClassName = classNames(styles.container, className, styles[`size-${size}`], {
      [styles.selected]: isSelected,
    });

    return (
      <button
        className={containerClassName}
        onClick={onClick}
        disabled={isDisabled}
        data-test={dataTest}
        ref={ref as LegacyRef<HTMLButtonElement>}
      >
        <div className={styles.content}>
          {icon && <div className={styles.icon}>{icon}</div>}
          <div className={styles.contentText}>
            <span className={styles.title}>{title}</span>
            {secondaryTitle && <span className={styles.secondaryTitle}>{secondaryTitle}</span>}
          </div>
          {suffix && <span className={styles.suffix}>{suffix}</span>}
        </div>
      </button>
    );
  })
);
